import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type InvoiceType = 'subscription' | 'installation' | '';
export interface InvoiceGenerationState {
  clientId: string;
  devices: string[];
  invoiceType: InvoiceType;
}

@Injectable({
  providedIn: 'root',
})
export class InvoiceGenerationStateService {
  // Observable state stream for dynamic updates.
  readonly state$ = new BehaviorSubject<InvoiceGenerationState>({
    clientId: '',
    devices: [],
    invoiceType: '',
  });
  // Selected client for the current invoice workflow.
  clientId = '';
  // Selected device identifiers (thing names).
  devices: string[] = [];
  // Invoice type to generate.
  invoiceType: InvoiceType = '';

  // Update and broadcast workflow state.
  setState(next: InvoiceGenerationState): void {
    this.clientId = next.clientId;
    this.devices = [...next.devices];
    this.invoiceType = next.invoiceType;
    this.state$.next({
      clientId: this.clientId,
      devices: [...this.devices],
      invoiceType: this.invoiceType,
    });
  }

  // Clear the current workflow state.
  reset(): void {
    this.clientId = '';
    this.devices = [];
    this.invoiceType = '';
    this.state$.next({
      clientId: '',
      devices: [],
      invoiceType: '',
    });
  }
}
